var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects"},[_c('div',{staticClass:"eyecatch",style:(("background-image: url(" + (this.eyecatch) + ")"))},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('projects')],1)}
var staticRenderFns = []

export { render, staticRenderFns }